import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';

type Props = {
  isPending: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
};

/**
 * Shown when booking creation asked the customer to confirm an out-of-season studded-tire date (backend
 * `booking_studded_tire_season_override_required`). The date is never refused — the booking is posted again with the
 * override once the customer has seen the rule. The rule is stated here rather than taken from the backend message,
 * which is written for the API caller.
 */
export const StuddedTireSeasonDialog = ({ isPending, onConfirm, onDismiss }: Props) => (
  <NoddiDialog
    open
    onClose={onDismiss}
    title={t`Studded tires outside the season`}
    footer={
      <div className='flex items-center justify-end gap-2'>
        <NoddiButton variant='outline' onClick={onDismiss} disabled={isPending}>
          <Trans>Pick a different date</Trans>
        </NoddiButton>
        <NoddiButton variant='success' loading={isPending} onClick={onConfirm}>
          <Trans>Book anyway</Trans>
        </NoddiButton>
      </div>
    }
  >
    <div className='flex flex-col gap-3'>
      <p>
        <Trans>
          Studded tires are allowed from 1 November until the first Sunday after Easter Monday, and from 16 October to
          30 April in Nordland, Troms and Finnmark. Outside that period they may only be used when snow or ice makes
          them necessary.
        </Trans>
      </p>
      <p>
        <Trans>You can still book this date — you are responsible for following the rule.</Trans>
      </p>
    </div>
  </NoddiDialog>
);
